<template>
  <div>
    <template v-if="getPaymentType">
      <component
        :is="getPaymentType.hosted_payment"
        :setting="getPaymentType"
        @onProceed="$emit('onProceed', $event)"
        :loading="loading"
        :disabled="disabled"
      />
    </template>
  </div>
</template>

<script>
import Paysolutions from './Paysolutions.vue'
import paymentMixin from '@/mixins/paymentMixin.js'
export default {
  mixins: [paymentMixin],
  inject: ['$validator'],
  components: {
    Paysolutions
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getPaymentType() {
      return this.getPaymentGatewayById(this.type)
    }
  }
}
</script>

<style lang="scss" scoped></style>
